import { DefaultTheme } from 'styled-components';

const dark:DefaultTheme = {
  title: 'dark',
  
  colors: {
    primary: '#6C63FF',
    secondary: '#FFAD7D',
    tertiary: '#68FF4A',

    background: '#1A1A1A',
    foreground: '#373737',
    title: '#FFF',
    text: '#FFF' 
  }
}

export default dark;